// project imports
import { THEME_CONFIG } from "config/app";

// action - state management
import * as actionTypes from "./actions";

export interface CustomizationState {
  fontFamily: string;
  borderRadius: number;
  query: string | null;
}

interface SetFontFamilyAction {
  type: typeof actionTypes.SET_FONT_FAMILY;
  fontFamily: string;
}

interface SetBorderRadiusAction {
  type: typeof actionTypes.SET_BORDER_RADIUS;
  borderRadius: number;
}

interface SearchAction {
  type: typeof actionTypes.SEARCH;
  query: string | null;
}

export type CustomizationAction =
  | SetFontFamilyAction
  | SetBorderRadiusAction
  | SearchAction;

export const initialState: CustomizationState = {
  fontFamily: THEME_CONFIG.fontFamily,
  borderRadius: THEME_CONFIG.borderRadius,
  query: null,
};

// ==============================|| CUSTOMIZATION REDUCER ||============================== //

const customizationReducer = (
  state: CustomizationState = initialState,
  action: CustomizationAction
): CustomizationState => {
  switch (action.type) {
    case actionTypes.SET_FONT_FAMILY:
      return {
        ...state,
        fontFamily: action.fontFamily,
      };
    case actionTypes.SET_BORDER_RADIUS:
      return {
        ...state,
        borderRadius: action.borderRadius,
      };
    case actionTypes.SEARCH:
      return {
        ...state,
        query: action.query,
      };
    default:
      return state;
  }
};

export default customizationReducer;
